module.exports = __webpack_public_path__ + "static/img/UTSG老师_老杜.3883996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSG/UTSG老师_老杜.png
// module id = Igox
// module chunks = 0